<div class="success-page " (click)="pageClick($event,sInx)" >
    <div class="col-12   head" style="{{'background-color:'+ page.style.bgColor +'66;'}}">
        <div style="width: 100%; text-align: start;" class="block lg:flex flex-wrap centerWidth">
            <div class="col-12 navicat">
                <div *ngIf="getDirection()=='rtl'"><span (click)="goToSuccessList()" i18n="@@Customers">Customers</span>
                    <span
                            class="pi pi-angle-left">  </span> <span> {{page.name}}</span></div>
                <div *ngIf="getDirection()=='ltr'"><span (click)="goToSuccessList()" i18n="@@Customers">Customers</span>
                    <span
                            class="pi pi-angle-right">  </span> <span> {{page.name}}</span></div>
            </div>
            <div class="col-12 lg:col-6 txt-pnl">
                <div>
                    <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.logoImage ">
                </div>
                <div>
                    <h2>
                        {{page.title}}
                    </h2>
                </div>
                <div *ngIf="page.summary != null || page.summary.length>0">
                    <p>
                        {{page.summary}}
                    </p>
                </div>
                <div class="col-12 block sm:flex flex-wrap">
                    <div  *ngFor="let field of page.attributeValues "
                         style="padding-top: 10px;"
                         class="col-12 sm:col-4 ">
                        <div class="t1">{{field.attribute }}</div>
                        <div *ngFor="let val of field.value.split(',') ">
                            <div  class="t2">{{val | numberText}}</div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="hidden lg:block col-12 lg:col-6 img-pnl">
                <svg width="958" height="688" viewBox="0 0 958 688" fill="none" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M-302.574 1159.96C-418.966 1029.28 -407.697 828.883 -277.405 712.359L76.7543 396.384L253.834 238.396L430.913 80.4072C561.206 -36.1165 761.182 -24.6409 877.574 106.039C993.966 236.719 982.697 437.117 852.405 553.641L144.087 1185.59C13.7945 1302.12 -186.182 1290.64 -302.574 1159.96Z"
                          [attr.fill]="page.style.bgColor"/>
                    <mask id="mask0_870_22151" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-383" y="0"
                          width="1341" height="1267">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M-302.574 1159.96C-418.966 1029.28 -407.697 828.883 -277.405 712.359L76.7543 396.384L253.834 238.396L430.913 80.4072C561.206 -36.1165 761.182 -24.6409 877.574 106.039C993.966 236.719 982.697 437.117 852.405 553.641L144.087 1185.59C13.7945 1302.12 -186.182 1290.64 -302.574 1159.96Z"
                              [attr.fill]="page.style.bgColor"/>
                    </mask>
                    <g mask="url(#mask0_870_22151)">
                        <rect x="148" y="69.6548" width="832" height="473" rx="8" fill="url(#pattern0)"/>
                    </g>
                    <g filter="url(#filter0_d_870_22151)">
                        <rect x="148" y="69.6548" width="655" height="473" rx="8" fill="url(#pattern1)"
                              shape-rendering="crispEdges"/>
                    </g>
                    <!--                <path d="M318.941 389.226C318.941 383.703 323.419 379.226 328.941 379.226H357.629C363.152 379.226 367.629 383.703 367.629 389.226V427.319H318.941V389.226Z"-->
                    <!--                      fill="white"/>-->
                    <defs>
                        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_870_22151" transform="scale(0.000525486 0.000925926)"/>
                        </pattern>
                        <filter id="filter0_d_870_22151" x="116" y="61.6548" width="719" height="537"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                           result="hardAlpha"/>
                            <feOffset dy="24"/>
                            <feGaussianBlur stdDeviation="16"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_870_22151"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_870_22151"
                                     result="shape"/>
                        </filter>
                        <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="2" height="2">
                            <use xlink:href="#image0_870_22151" transform="scale(0.000667487 0.000925926)"/>
                        </pattern>
                        <image *ngIf="page.style.bgImage!= null && page.style.bgImage.length>5 " id="image0_870_22151"
                               width="1920" height="1080"
                               [attr.xlink:href]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.bgImage"/>
                    </defs>
                </svg>
            </div>
            <div class="block  lg:hidden col-12 lg:col-6 img-pnl">
                <img style="width: 100%;" [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.bgImage">
            </div>
        </div>
    </div>

    <div  class="success-body col-12 flex centerWidth ">
        <div class="col-12 {{indexList.length>0 && page.showIndex ?'lg:col-8':'lg:col-12'}}" >
            <section id="sec_{{section.id}}" *ngFor="let section of page.pageSections; let j=index">
                <ng-container *ngFor="let item of section.items; let i=index">
                    <div class=" {{item.display_mode==null || item.display_mode=='' ?'': item.display_mode=='lg'?'md:hidden-item sm:hidden-item':item.display_mode=='md'?'lg:hidden-item sm:hidden-item':item.display_mode=='sm'?' lg:hidden-item md:hidden-item':''}} "
                         style="margin-top: 20px;z-index: 2;"
                    >

                        <div class="flex" *ngIf="item.type=='TITLE'">
                            <img style="margin: 0px 10px;"
                                 *ngIf="item.body['imgUid']!= null && item.body['imgUid'].length>0 "
                                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] ">
                            <h2 id="{{j+''+i}}" class="section-title">{{item.body['text']}}</h2>
                        </div>


                        <div *ngIf="item.type=='TEXT'" [innerHTML]="item.body['text'] | safeHtmlPipe"></div>
                        <div *ngIf="item.type=='HTML'" [innerHtml]="item.body['code']"></div>

                        <div *ngIf="item.type=='AUTHOR'" class="author flex">
                            <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] ">
                            <div>{{item.body['name']}}</div>
                            <div> -</div>
                            <div>{{item.body['desc']}}</div>
                        </div>

                        <video *ngIf="item.type=='VIDEO'" width="100%" controls>
                            <source src="{{item.body['src']}}"
                                    type="video/mp4">
                        </video>

                        <img *ngIf="item.type=='PHOTO'"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] "
                             [alt]="item.body['name']"/>

                        <div *ngIf="item.type=='SEPARATOR'" class="separator"></div>
                        <div *ngIf="item.type=='ACCORDION'">
                            <p-accordion>
                                <p-accordionTab *ngFor="let accordi of item.body['list']; let i=index "
                                                [header]="accordi['title']">
                                    <p>
                                        {{accordi['text']}}
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                        </div>
                        <div *ngIf="item.type=='INNER'" [innerHTML]="item.body['code'] |safeHtmlPipe"></div>
                    </div>

                </ng-container>
            </section>
        </div>

        <div id="side-index" [hidden]="indexList.length<1" style="{{page.showIndex==null || !page.showIndex ? 'display:none':''}}" class=" side-index col-12 lg:col-4 " >
            <div>
                <div class="font-bold flex" (click)="toggelSideIndex(sInx)">
                    <div class="col-10" i18n="@@You read in this story"> You read in this story</div>
                    <div style="text-align: end;" class="block md:hidden col-2 pi
                        {{sInx.classList.contains('hidden') ? ( getDirection()=='rtl' ? 'pi-angle-left' : 'pi-angle-right') :'pi-angle-down' }}  "
                         ></div>
                </div>
                <div #sInx class="hidden lg:block">
                    <ul>
                        <li id="{{'li_'+item.id}}" *ngFor="let item of indexList"
                            (click)="goToFregment(item.id);toggelSideIndex(sInx);">
                            <div>&nbsp;</div>
                            <span>{{item.value}}</span></li>
                    </ul>
                    <button class="button darkblue" (click)="goToDashboard()">
                        <span i18n="@@Start Free">Start Free</span>
                        <i class="pi pi-angle-left"></i>
                    </button>
                </div>
            </div>


        </div>
    </div>
    <app-success-story i18n-title="@@Other Story" title="Other Story" [showDet]="false"></app-success-story>
    <!--    <app-performance-section></app-performance-section>-->

</div>
